import { useQuery } from '@tanstack/react-query';

import { fetchSearchDiagnoses } from '../api/searchDiagnoses.js';
import { rxKeys } from './keys.js';

export function useSearchDiagnosesQuery(searchTerm: string | undefined) {
  const trimmed = searchTerm?.trim() ?? '';
  const enabled = trimmed.length >= 2;

  return useQuery({
    queryKey: rxKeys.diagnosesSearch(trimmed),
    queryFn: ({ signal }) => fetchSearchDiagnoses({ search_term: trimmed }, signal),
    enabled,
  });
}
